import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD, RESET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError, resetPasswordError, resetPasswordSuccess } from "./actions"

//Include Both Helper File with needed methods
import { forgotPassword, resetPassword as resetPasswordApi } from "../../../helpers/auth_helper"

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    // POST /api/auth/forgot-password — always 200 (silent on unknown emails).
    yield call(forgotPassword, user.email);
    yield put(userForgetPasswordSuccess("Email successfully sent"));
  } catch (error) {
    yield put(userForgetPasswordError(error?.response?.data?.message || error?.message || "An error occurred"));
  }
}

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* resetPassword({ payload: { data, history } }) {
  try {
    // POST /api/auth/reset-password { token, newPassword }
    yield call(resetPasswordApi, { token: data.token, newPassword: data.newPassword ?? data.password });
    yield put(resetPasswordSuccess("Reset password successful"))
  } catch (error) {
    yield put(resetPasswordError(error?.response?.data?.message || error))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

export function* watchUserPasswordReset() {
  yield takeEvery(RESET_PASSWORD, resetPassword)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget), fork(watchUserPasswordReset)])
}

export default forgetPasswordSaga;
